export default __webpack_public_path__ + "static/media/open.88b6f82d.svg";